import gql from 'graphql-tag';

export const schema = gql`
  query GetPublicationImages($publicationId: String!) {
    getPropertyListingPublication(id: $publicationId) {
      __typename
      ... on GetPropertyListingPublicationSuccess {
        publication {
          id
          images {
            attachmentId
            url
            fileName: tag(key: "originalFileName") {
              value
            }
          }

          images_order: attribute(key: "media/images_order") {
            mediaImagesOrder {
              order
            }
          }
        }
      }

      ... on GetPropertyListingPublicationFailure {
        error {
          code
          message
          metadata {
            key
            value
          }
        }
      }
    }
  }
`;
